// extracted by mini-css-extract-plugin
module.exports = {"table":"PriceTable_table__QE2qj"};